import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
import { saveAs } from 'file-saver'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 导入自定义对象数据的模板
export const customPageImportUrl = '/crm/importCenter/template/'
// 获取预定义对象的导入字段列表
export const getImportColumnListApi = (data: any) =>
  request.post(`/crm/importCenter/importColumnList/${data.tableCode}`, data)
// 导入文件-映射完成导入提交
export const submitImportApi = (data: any) =>
  request.upload({
    url: '/crm-report/importCenter/start',
    data
  })
// 轮询导入状态
export const getImportStatusApi = (data: any) =>
  request.post(`/crm-report/importCenter/getImportStatus/${data}`, data)
// 导出失败结果
export const downFailResultApi = (data: any) => {
  return request
    .post(`/crm-report/importCenter/downFailResult/${data}`, data, {
      responseType: 'blob'
    })
    .then(res => {
      const blob = new Blob([res.data])
      const name = res.filename
        ? res.filename
        : new Date().getTime() + '_' + parseInt(Math.random() * 10000) + '.xlsx'
      saveAs(blob, name)
    })
    .finally(() => {})
}
// 导入excel解析excel表头
export const importFilesAnalysisExcelHeadApi = (data: any) =>
  request.upload({
    url: '/crm-report/importCenter/analysisExcelHead',
    data
  })
// 获取导入列表
export const getImportList = (data: any) =>
  request.post('/crm-report/importCenter/list', data, jsonHeaderConfig)
// 删除
export const fileDelete = (data: any) =>
  request.post(`/crm-report/importCenter/delete/${data}`, data)
